var _defs, _path, _path2, _use, _use2, _path3, _use3, _use4, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFirefoxLite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 549 549",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "A",
    cx: 445,
    cy: 58,
    r: 532,
    xlinkHref: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#ffbd4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#ffac31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#ff9d17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#ff980e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ff563b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#ff3750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#f5156c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#eb0878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#e50080"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "B",
    cx: 250,
    cy: 275,
    r: 532,
    xlinkHref: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#960e18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#cc2335",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#f13148",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#ff3750",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "C",
    cx: 315,
    cy: -63,
    r: 386,
    xlinkHref: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#fff44f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#ffdc3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ff9d12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#ff980e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "D",
    cx: 191,
    cy: 414,
    r: 253,
    xlinkHref: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3a8ee6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#5c79f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#9059ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c139e6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "E",
    cx: -10117,
    cy: -9406,
    r: 20.4,
    gradientTransform: "matrix(6.402 -1.549 1.814 7.499 82093 55079)",
    xlinkHref: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#9059ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#8439d5",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#7410a0",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#6e008b",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "F",
    cx: 247,
    cy: 36,
    r: 182,
    xlinkHref: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#ffdb27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffc82a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ffa930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#ff7e37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#ff7139"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "G",
    cx: 387,
    cy: -80,
    r: 778,
    xlinkHref: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fff44f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#ff980e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#ff5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#ff3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#d21f7e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "H",
    cx: -10108,
    cy: -9437,
    r: 87,
    gradientTransform: "matrix(.6895 6.551 -4.298 .4524 -33276 70495)",
    xlinkHref: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff44f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#ffe847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#ffc830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ff980e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#ff8b16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#ff672a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#ff3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#d21f7e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "I",
    cx: 239,
    cy: 103,
    r: 486,
    xlinkHref: "#P"
  }, "q\n            ", /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#fff44f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#ff980e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#ff5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ff3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#d21f7e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "J",
    cx: 368,
    cy: 132,
    r: 532,
    xlinkHref: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff44f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#ffe141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ffaf1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#ff980e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    x1: 468,
    x2: 44,
    y1: 83,
    y2: 492,
    xlinkHref: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#fff44f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#ffe847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#ffc830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#ff980e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ff8b16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#ff672a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#ff3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#d21f7e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    x1: 463,
    x2: 102,
    y1: 81,
    y2: 442,
    xlinkHref: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#fff44f",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#fff44f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    x1: 266,
    x2: 543,
    y1: 408,
    y2: 525,
    xlinkHref: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#0a84ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#0f7efd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3f48ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#6321e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#7809da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8000d7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "N",
    d: "M502 178c-11-27-34-56-51-65 14 28 23 56 26 77 24 65 11 132-8 172-30 65-101 129-212 126-120-3-225-92-245-209-4-18 0-28 2-43-2 11-3 15-4 35v1c0 141 114 255 255 255 126 0 231-92 252-212 0-3 1-7 1-10 5-42 0-88-16-127z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O",
    d: "M266 224c0 6-23 28-31 28-73 0-84 44-84 44 3 37 29 67 60 84 1 1 3 1 4 2 3 1 5 2 7 3 11 4 22 6 33 6 127 6 152-152 60-198 24-4 48 5 62 15-22-39-64-65-112-65h-9c-26 2-51 12-70 27 4 3 8 8 18 17 17 17 62 35 62 37z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    gradientUnits: "userSpaceOnUse"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2b55aa",
    d: "M481 343H259c-7 0-12 5-12 12v36c0 52 42 95 95 95h123c39 0 71-32 71-71v-31c0-19-18-41-55-41z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#K)",
    d: "M502 178c-11-27-34-56-51-65 14 28 23 56 26 77-30-70-79-99-119-163-2-3-4-6-6-10-1-2-2-4-3-5-3-6-4-10-4-10s0-1-1-1c-64 38-86 107-88 142-26 2-51 12-70 27-2-2-4-3-7-5-10-33-1-62-1-62-26 12-47 31-61 47-10-13-9-55-9-64 0-1-8 4-9 5-6 4-15 12-25 21a218.9 218.9 0 00-58 106v2c0 2-2 13-3 16v1c-2 11-4 23-4 35v1c0 141 114 255 255 255 126 0 231-92 252-212 0-3 1-7 1-10 6-43 1-89-15-128zM207 378c1 1 2 1 4 2-1-1-2-1-4-2zm269-186s0-1 0 0c0-1 0 0 0 0z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "url(#A)",
    xlinkHref: "#N"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    fill: "url(#B)",
    xlinkHref: "#N"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#C)",
    d: "M378 208c1 0 1 1 2 1-6-11-14-21-24-31C277 99 335 6 345 1c-64 38-86 107-88 142h9c48 0 89 26 112 65z"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    fill: "url(#D)",
    xlinkHref: "#O"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    fill: "url(#E)",
    xlinkHref: "#O"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#F)",
    d: "M175 162c2 1 4 2 5 4-10-33-1-62-1-62-26 12-47 31-61 47 1 0 38-1 57 11z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#G)",
    d: "M12 279c20 116 125 205 245 209 111 3 182-61 211-124 19-41 32-107 8-172 9 59-21 116-68 155-92 75-179 45-197 33-1-1-2-1-4-2-53-26-75-74-71-116-45 0-60-38-60-38s40-29 94-4c49 23 96 4 96 4 0-2-45-20-62-37-9-9-14-14-18-17-2-2-4-3-7-5-2-1-3-2-5-4-19-12-56-11-57-11-10-13-9-55-9-64 0-1-8 4-9 5-6 4-15 12-25 21a218.9 218.9 0 00-58 106c1 1-8 41-4 61z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#H)",
    d: "M355 179c10 10 18 20 24 31 1 1 3 2 4 3 58 53 28 129 25 134 47-39 77-96 68-155-29-72-78-101-118-165-2-3-4-6-6-10-1-2-2-4-3-5-3-6-4-10-4-10s0-1-1-1c-9 5-68 98 11 178z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#I)",
    d: "M383 213c-1-1-2-2-4-3-1 0-1-1-2-1-14-10-38-19-62-15 92 46 67 204-60 198-11-1-22-2-33-6-2-1-5-2-7-3-1-1-3-1-4-2 18 12 105 42 197-33 2-7 33-82-25-135z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#J)",
    d: "M151 296s12-44 84-44c8 0 30-22 31-28 0 0-46 19-96-4-53-25-94 4-94 4s15 38 60 38c-5 42 17 90 71 116 1 1 2 1 4 2-31-16-57-47-60-84z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#L)",
    d: "M502 178c-11-27-34-56-51-65 14 28 23 56 26 77-30-70-79-99-119-163-2-3-4-6-6-10-1-2-2-4-3-5-3-6-4-10-4-10s0-1-1-1c-64 38-86 107-88 142h9c48 0 90 26 112 65-14-10-38-19-62-15 92 46 67 204-60 198-11-1-22-2-33-6-2-1-5-2-7-3-1-1-3-1-4-2s-2-1-4-2c1 1 2 1 4 2-31-16-57-47-60-84 0 0 12-44 84-44 8 0 30-22 31-28 0-2-45-20-62-37-9-9-14-14-18-17-2-2-4-3-7-5-10-33-1-62-1-62-26 12-47 31-61 47-10-13-9-55-9-64 0-1-8 4-9 5-6 4-15 12-25 21a218.9 218.9 0 00-58 106v2c0 2-3 14-3 16-2 11-3 24-4 36v1c0 141 114 255 255 255 126 0 231-92 252-212 0-3 1-7 1-10 6-43 1-89-15-128zm-26 13s0 1 0 0c0 1 0 1 0 0z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#M)",
    d: "M524 395H320a88 88 0 00-88 87v43c0 7 5 12 12 12h204c48 0 88-39 88-88v-67c0 8-6 13-12 13z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M291 501v-67h12v57h29v10zm69-66v67h-12v-67zm15 10v-10h53v10h-21v57h-12v-57zm68 56v-67h43v10h-31v18h29v10h-29v18h32v10z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirefoxLite);
export default __webpack_public_path__ + "static/media/firefox-lite.a699f5eb16aeacf101c5520ed8bd40ee.svg";
export { ForwardRef as ReactComponent };